<template>
  <div class="field-array__container">
    <v-btn
      @click="addLine"
      class="primary field-array__add-button"
    >
      <v-icon v-text="'add'" /> adicionar
    </v-btn>
    <ul>
      <li v-for="(item, idx) in value" :key="idx">
        <template v-for="(key, idz) in Object.keys(item)">
          <v-text-field
            :label="translate(key)"
            v-model="item[key]"
            :key="idz"
          />
        </template>
        <v-icon
          @click.prevent="removeItem(idx)"
          v-text="'delete'"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator'

export default {
  mixins: [abstractField],
  methods: {
    addLine () {
      const model = {
        title: '',
        description: '',
        position: 0
      }

      if (!this.value.length) {
        this.value = [model]
        return
      }

      this.value.push(this.cloneWithoutValues(this.value[0]))
    },
    cloneWithoutValues (obj) {
      return this.clone(obj, true)
    },
    clone (obj, isWithoutValue) {
      var copy

      // Handle the 3 simple types, and null or undefined
      if (obj === null || typeof obj !== 'object') return obj

      // Handle Date
      if (obj instanceof Date) {
        copy = new Date()
        copy.setTime(obj.getTime())
        return copy
      }

      // Handle Array
      if (obj instanceof Array) {
        copy = []
        for (var i = 0, len = obj.length; i < len; i++) {
          copy[i] = this.clone(obj[i])
        }
        return copy
      }

      // Handle Object
      if (obj instanceof Object) {
        copy = {}
        for (var attr in obj) {
          if (isWithoutValue) {
            if (obj.hasOwnProperty(attr)) copy[attr] = ''
          } else {
            if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr])
          }
        }
        return copy
      }

      throw new Error('Unable to copy obj! Its type isn\'t supported.')
    },

    removeItem (index) {
      this.value.splice(index, 1)
    },

    translate (item) {
      const translations = this.schema.translations || {
        title: 'Nome',
        description: 'Valor',
        position: 'Posição'
      }
      return translations[item]
    }
  }
}
</script>
<style lang="stylus">
  .field-array__container
    position relative
    width 100%

    .field-array__add-button
      position absolute
      right -5px
      top -30px
      padding 5px !important
      height auto

      .v-icon
        font-size 17px
        opacity 1

      .v-btn__content
        font-size 10px
        font-weight 700

    ul
      margin-top 30px
      display flex
      width 100%
      flex-direction column
      padding 0

      li
        display grid
        width 100%
        grid-template-areas 'title position' 'description delete'
        grid-template-columns 90% 1fr
        margin-bottom 40px

        .v-icon
          grid-area delete
          align-self center
          justify-self center

        .v-text-field
          width 100%

          &:nth-child(2)
            grid-area description
            padding-right 30px

          &:nth-child(3)
            grid-area position
            input
              text-align center

          &:nth-child(1)
            grid-area title
            padding-right 30px

          &:last-child
            margin-right 0

</style>
